import {NameValueDTO} from '../../common/models/NameValueDTO';
import {BaseDTO} from '../../common/models/BaseDTO';
import {NationalDrugFormularyDTO} from './NationalDrugFormularyDTO';
import {RefillDTO} from './RefillDTO';
import {GrandfatherDTO} from './GrandfatherDTO';

export class DrugManagementPlanDTO extends BaseDTO {
  drugManagementPlanId: number;
  name: string;
  startDate: Date;
  endDate: Date;
  administrator: NameValueDTO;
  payer: NameValueDTO;
  policy: NameValueDTO;
  policyHolder: NameValueDTO;
  policyHolderGroup: NameValueDTO;
  product: NameValueDTO;
  reinsurer: NameValueDTO;

  refills: RefillManPlanLinkDTO[];
  prescriptionLimits: PrescriptionLimitDTO[];
  therapeuticDuplications: TherapeuticDuplicationDTO[];
  stepTherapies: StepTherapyManPlanLinkDTO[];
  nationalDrugFormularies: NationalDrugFormularyManPlanLinkDTO[];
  grandfathers: GrandfatherManPlanLinkDTO[];
}

export class PrescriptionLimitDTO extends BaseDTO {
  prescriptionLimitId: number;
  name: string;
  value: number;
  prescriptionLimitType: NameValueDTO;
  startDate: Date;
  endDate: Date;
}

export class TherapeuticDuplicationDTO extends BaseDTO {
  therapeuticDuplicationId: number;
  applyTherapeuticDuplication: number;
  applyLevelFour: number;
  applyLevelFourDosage: number;
  levelFourDosageIndicator: number;
  applyLevelFive: number;
  applyLevelFiveDosage: number;
  levelFiveDosageIndicator: number;
  startDate: Date;
  endDate: Date;
}

export class StepTherapyDTO {
  stepTherapyId: number;
  name: string;
}

export class RefillManPlanLinkDTO extends BaseDTO {
  refill: RefillDTO;
  startDate: Date;
  endDate: Date;
}

export class StepTherapyManPlanLinkDTO extends BaseDTO {
  stepTherapy: StepTherapyDTO;
  startDate: Date;
  endDate: Date;
}

export class NationalDrugFormularyManPlanLinkDTO extends BaseDTO {
  nationalDrugFormulary: NationalDrugFormularyDTO;
  startDate: Date;
  endDate: Date;
}

export class GrandfatherManPlanLinkDTO extends BaseDTO {
  grandfather: GrandfatherDTO;
  startDate: Date;
  endDate: Date;
}
